// extracted by mini-css-extract-plugin
export default {"menubarWrapper":"MenuBar_menubarWrapper__c-b8w","button":"MenuBar_button__Hkzef","activeButton":"MenuBar_activeButton__xWn0T"};